export default {
    personalPickupsOrders: [],
    personalPickupsOrdersLoading: false,
    personalPickups: [],
    personalPickupsLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        shopOrderNumber: null,
        customerName: null,
        customerId: null,
    }
}

